import * as React from 'react'

const SvgBackpack = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={144}
    height={120}
    viewBox="0 0 144 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Backpack_svg__a)">
      <path
        d="M74.993 34.022h-5.991c-5.19 0-9.408-4.096-9.408-9.134V9.17c0-5.054 4.234-9.17 9.444-9.17h5.919c5.21 0 9.443 4.116 9.443 9.17v15.717c0 5.04-4.218 9.135-9.407 9.135ZM69.043 6.12c-1.736 0-3.147 1.37-3.147 3.056v15.717c0 1.666 1.395 3.022 3.11 3.022H75c1.715 0 3.11-1.356 3.11-3.022V9.176c0-1.687-1.41-3.057-3.147-3.057h-5.918ZM131.153 114.279h-4.197c-5.708 0-10.346-4.504-10.346-10.047V71.249h14.302c5.052 0 9.16 3.984 9.16 8.895v25.474c0 4.778-3.997 8.661-8.919 8.661Z"
        fill="#7130C9"
      />
      <path
        d="M135.303 71.249h-18.694v21.515h21.233c4.024 0 6.963-3.684 5.96-7.469l-2.539-9.563c-.703-2.639-3.153-4.483-5.96-4.483Z"
        fill="#E1CEFF"
      />
      <path
        d="M100.046 15.396H31.735c-3.07 0-5.666 2.19-6.091 5.14L13.25 105.986C12.176 113.387 18.1 120 25.796 120h79.869c7.697 0 13.62-6.613 12.545-14.015l-12.435-85.749c-.404-2.776-2.849-4.84-5.734-4.84h.005Z"
        fill="#440A78"
      />
      <path
        d="M25.56 21.383h23.452v-5.987H31.714c-3.4 0-6.154 2.675-6.154 5.976v.01Z"
        fill="#7130C9"
      />
      <path
        d="M116.326 15.396H48.298c-3.069 0-5.666 2.19-6.09 5.14l-12.399 85.438C28.734 113.382 34.657 120 42.36 120h79.906c7.702 0 13.626-6.618 12.55-14.026l-12.398-85.437c-.43-2.95-3.027-5.14-6.091-5.14Z"
        fill="#9865FC"
      />
      <path
        d="M53.078 71.249h59.943c5.425 0 9.827 4.274 9.827 9.542v24.827c0 4.778-3.998 8.661-8.92 8.661H52.176c-4.922 0-8.92-3.883-8.92-8.661V80.791c0-5.268 4.402-9.542 9.827-9.542h-.005ZM12.254 71.249h12.361c3.07 0 5.436 2.634 5.021 5.589l-4.549 32.275c-.414 2.96-3.022 5.166-6.096 5.166h-8.909c-3.4 0-6.154-2.675-6.154-5.976V79.334c0-4.463 3.725-8.085 8.326-8.085Z"
        fill="#7130C9"
      />
      <path
        d="M43.251 71.249h79.592v12.854c0 4.779-3.998 8.66-8.92 8.66H52.171c-4.922 0-8.92-3.881-8.92-8.66V71.249ZM8.697 71.249h21.726l-3.032 21.515H6.158c-4.025 0-6.963-3.684-5.96-7.469l2.539-9.563c.703-2.639 3.153-4.483 5.96-4.483Z"
        fill="#E1CEFF"
      />
      <path
        d="M78.141 92.764h9.812v4.962c0 2.517-2.104 4.565-4.701 4.565h-.41c-2.591 0-4.7-2.043-4.7-4.565v-4.962Z"
        fill="#FFC103"
      />
      <path d="M87.953 83.237H78.14v9.527h9.812v-9.527Z" fill="#7130C9" />
      <path
        d="m120.083 53.071-75.52.255c-3.746.015-6.637-3.205-6.112-6.806l3.761-25.978c.425-2.95 3.028-5.146 6.092-5.146h68.022c3.064 0 5.667 2.19 6.092 5.14l3.735 25.724c.52 3.586-2.34 6.796-6.07 6.811Z"
        fill="#E1CEFF"
      />
      <path
        d="M78.141 53.352h9.812v4.962c0 2.517-2.104 4.565-4.701 4.565h-.41c-2.591 0-4.7-2.043-4.7-4.565v-4.962Z"
        fill="#FFC103"
      />
      <path d="M87.953 43.824H78.14v9.527h9.812v-9.527Z" fill="#7130C9" />
    </g>
    <defs>
      <clipPath id="Backpack_svg__a">
        <path fill="#fff" d="M0 0h144v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBackpack
